import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginationComponent } from '../pagination/pagination.component';

export interface TableColumn {
  key: string;
  label: string;
  type?: 'text' | 'badge' | 'icon' | 'boolean' | 'button';
  badgeMap?: Record<string, string>;
  buttonLabel?: string;
  buttonIcon?: string;
  buttonVisibleKey?: string;
  buttonLabelKey?: string;
  emptyPlaceholder?: string;
}

export type TableAction = 'edit' | 'changePassword' | 'settings' | 'delete';

@Component({
  selector: 'app-table',
  imports: [PaginationComponent],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss'
})
export class TableComponent {
  @Input() columns: TableColumn[] = [];
  @Input() data: any[] = [];
  @Input() showActions = true;
  @Input() actions: TableAction[] = ['edit', 'settings', 'delete'];

  @Input() showPagination = false;
  @Input() currentPage = 1;
  @Input() pageSize = 10;
  @Input() totalItems = 0;

  @Output() edit = new EventEmitter<any>();
  @Output() changePassword = new EventEmitter<any>();
  @Output() settings = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() columnAction = new EventEmitter<{ key: string; row: any }>();
  @Output() pageChange = new EventEmitter<number>();

  badgeClass(value: string, col: TableColumn): string {
    return col.badgeMap?.[value] ?? 'secondary';
  }
}
